export default __webpack_public_path__ + "static/lion2-4c7e2ecf851af288cc3e7b030eb8c679.png";